const chartjs = require('../../../../../../components/chart/chartjs')
const { changeSVG } = require('../../../../../../js-handler/graphic')
const settings = require('../../../../../../js-handler/settings')

let barSimpleChart = null;

export function createChart(parameter) {
	const canvas = document.getElementById('chartBarClientActivity');
	// const datetimeSpan = document.getElementById('datetimeSpanPayable');
	// const companyName = document.getElementById('companyNamePayable');
	const companiesName = document.getElementById('companiesName');

	// companyName.textContent = parameter[0].company_name;
	// datetimeSpan.textContent = `${parameter[0].current_dateTime}`;
	companiesName.textContent = `${settings.getData().name} and ${settings.getData().company}`;

	// Destruye el gráfico anterior si existe
	if (barSimpleChart) {
		barSimpleChart.destroy();
		barSimpleChart = null;
	}

	const totalPurchase = parseFloat((parameter[0].total_purchase || '0').replace(/[^0-9.-]+/g, ""));
	const totalSale = parseFloat((parameter[0].total_sale || '0').replace(/[^0-9.-]+/g, ""));

	// Prepara los datos para el gráfico
	const chartData = {
		labels: ['Total Receivable', 'Total Payable'],
		dataset: [
			{
				label: 'Activity',
				backgroundColor: ['#4bc0c0', '#ff2857'],
				data: [totalPurchase, totalSale],
			}
		]
	};

	//Crear gráfico solo una vez con los totales
	barSimpleChart = chartjs.start({
		elem: 'bar',
		act: 'createMultipleLineWithLabels',
		targetChart: { html: canvas },
		data: chartData,
		options: {
			aspectRatio: 10 / 4.06,
			legend: false
		}
	});

	if (!canvas) {
		console.log('Canvas chartBarReceivable no encontrado');
		return;
	}

}